import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
/* eslint-disable jsx-a11y/anchor-is-valid */
import styled from "@emotion/styled";
import { DEFAULT_WALLET_PROVIDERS, DefaultWalletType, useSolana, } from "@saberhq/use-solana";
import { useState } from "react";
import { LabeledInput } from "../../LabeledInput";
import { ButtonWithFooter } from "../ButtonWithFooter";
export const WalletStepLedgerAdvanced = ({ onBack, onSuccess, onError, }) => {
    const [accountStr, setAccountStr] = useState("");
    const [changeStr, setChangeStr] = useState("");
    const { activate } = useSolana();
    return (_jsxs(Wrapper, { children: [_jsx(IconWrapper, { children: _jsx(DEFAULT_WALLET_PROVIDERS.Ledger.icon, {}) }), _jsx("h2", { children: "Enter your Ledger account info" }), _jsxs("p", { children: ["Not sure what to enter here? You\u2019re probably looking for the basic", " ", _jsx("strong", { children: "Ledger Connect" }), "."] }), _jsxs(Fields, { children: [_jsx(LabeledInput, { label: "Account", placeholder: "Root", name: "account", value: accountStr, onChange: (e) => {
                            setAccountStr(e.target.value);
                        } }), _jsx(LabeledInput, { label: "Change", placeholder: "Root", name: "change", value: changeStr, onChange: (e) => {
                            setChangeStr(e.target.value);
                        } })] }), _jsx(ButtonWithFooter
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            , { 
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick: async () => {
                    try {
                        const account = accountStr === "" ? undefined : parseInt(accountStr);
                        const change = changeStr === "" ? undefined : parseInt(changeStr);
                        await activate(DefaultWalletType.Ledger, {
                            account,
                            change,
                        });
                    }
                    catch (e) {
                        onError === null || onError === void 0 ? void 0 : onError(e);
                        return;
                    }
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                }, footer: _jsxs(_Fragment, { children: ["Having trouble?", " ", _jsx("a", { href: "#", onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onBack === null || onBack === void 0 ? void 0 : onBack();
                            }, children: "Go back" })] }), children: "Continue" })] }));
};
const IconWrapper = styled.div `
  & > svg,
  & > img {
    width: 36px;
    height: 36px;
  }
  margin-bottom: 32px;
`;
const Wrapper = styled.div `
  padding: 28px;
  padding-top: 67px;

  & > h2 {
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -0.02em;
    color: #000000;
  }

  & > p {
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.02em;
    color: #696969;
  }
`;
const Fields = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
//# sourceMappingURL=index.js.map